'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnconnectedLauncher = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _fa = require('react-icons/lib/fa');

var _fluxWrapper = require('../../../higherOrder/pickupLocations/fluxWrapper');

var _fluxWrapper2 = _interopRequireDefault(_fluxWrapper);

var _Geolocation = require('../Geolocation');

var _Geolocation2 = _interopRequireDefault(_Geolocation);

var _pickupLocatorLauncherStyles = require('./pickupLocatorLauncherStyles.scss');

var _pickupLocatorLauncherStyles2 = _interopRequireDefault(_pickupLocatorLauncherStyles);

var _FormInput = require('../../FormInput');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickupLocatorLauncher = function (_React$Component) {
  (0, _inherits3.default)(PickupLocatorLauncher, _React$Component);

  function PickupLocatorLauncher(props) {
    (0, _classCallCheck3.default)(this, PickupLocatorLauncher);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PickupLocatorLauncher.__proto__ || (0, _getPrototypeOf2.default)(PickupLocatorLauncher)).call(this, props));

    _this.state = { term: props.initialTerm };
    return _this;
  }

  (0, _createClass3.default)(PickupLocatorLauncher, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.gps) {
        this.setState({ term: '' });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      this.setState({ term: event.target.value });
    }
  }, {
    key: 'launch',
    value: function launch() {
      var _this2 = this;

      this.props.open(this.state.term, function () {
        return _this2.props.search(_this2.state.term);
      });
    }
  }, {
    key: 'launchWithLocation',
    value: function launchWithLocation(location) {
      var _this3 = this;

      this.props.open(location, function () {
        return _this3.props.search(location);
      });
    }
  }, {
    key: 'change',
    value: function change() {
      var _this4 = this;

      if (this.state.term !== '') {
        this.props.open(this.state.term, function () {
          return _this4.props.search(_this4.state.term);
        });
      } else {
        this.props.open(this.initialCoords(), function () {
          return _this4.props.search(_this4.initialCoords());
        });
      }
    }
  }, {
    key: 'initialCoords',
    value: function initialCoords() {
      var coords = this.props.initialTerm.split(', ');

      return { latitude: coords[0], longitude: coords[1] };
    }
  }, {
    key: 'searcher',
    value: function searcher() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          { styleName: 'header' },
          'Find a collection point'
        ),
        _react2.default.createElement(
          'h3',
          { styleName: 'subHeader' },
          'Search by address'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'searchBox' },
            _react2.default.createElement(_FormInput.Input, {
              type: 'text',
              autoComplete: 'off',
              value: this.state.term,
              onChange: this.onChange.bind(this),
              styleName: this.props.gps ? 'collectionSearch gps' : 'collectionSearch',
              placeholder: this.props.gps ? 'Your location' : 'Enter address or postcode'
            }),
            _react2.default.createElement(
              _Geolocation2.default,
              {
                role: 'button',
                search: this.launchWithLocation.bind(this),
                canUseGps: this.props.canUseGps,
                gpsUnavailable: this.props.gpsUnavailable
              },
              _react2.default.createElement(
                'div',
                { styleName: 'locate' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_fa.FaCrosshairs, null)
                )
              )
            )
          ),
          _react2.default.createElement(
            _FormInput.Button,
            {
              type: 'button',
              onClick: this.launch.bind(this),
              styleName: 'collectionLaunch'
            },
            'Select Collection Point'
          )
        )
      );
    }

    // TODO: eliminate the duplication between here and addressbook

  }, {
    key: 'hiddenForm',
    value: function hiddenForm() {
      var key = 'order[ship_address_attributes]';
      var details = this.props.addressDetails.ship;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('input', {
          name: key + '[firstname]',
          value: details.firstName,
          type: 'hidden'
        }),
        _react2.default.createElement('input', {
          name: key + '[lastname]',
          value: details.lastName,
          type: 'hidden'
        }),
        _react2.default.createElement('input', {
          name: key + '[address1]',
          value: details.address1,
          type: 'hidden'
        }),
        _react2.default.createElement('input', {
          name: key + '[address2]',
          value: details.address2,
          type: 'hidden'
        }),
        _react2.default.createElement('input', {
          name: key + '[city]',
          value: details.city,
          type: 'hidden'
        }),
        _react2.default.createElement('input', {
          name: key + '[zipcode]',
          value: details.zipcode,
          type: 'hidden'
        }),
        _react2.default.createElement('input', {
          name: key + '[state_name]',
          value: details.state_name,
          type: 'hidden'
        }),
        _react2.default.createElement('input', {
          name: key + '[phone]',
          value: details.phone,
          type: 'hidden'
        }),
        _react2.default.createElement('input', {
          name: key + '[location_code]',
          value: details.location_code,
          type: 'hidden'
        })
      );
    }
  }, {
    key: 'summary',
    value: function summary() {
      var details = this.props.addressDetails;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          { styleName: 'header' },
          details.ship.firstName
        ),
        _react2.default.createElement(
          'h3',
          null,
          details.ship.address1
        ),
        _react2.default.createElement(
          'p',
          null,
          details.ship.address2,
          ' ',
          _react2.default.createElement('br', null),
          details.ship.city,
          ' ',
          _react2.default.createElement('br', null),
          details.ship.zipcode
        ),
        _react2.default.createElement(
          _FormInput.Button,
          {
            type: 'button',
            styleName: 'collectionLaunch',
            onClick: this.change.bind(this)
          },
          'Change location'
        ),
        this.hiddenForm()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.confirmed ? this.summary() : this.searcher();
    }
  }]);
  return PickupLocatorLauncher;
}(_react2.default.Component);

var UnconnectedLauncher = exports.UnconnectedLauncher = (0, _reactCssModules2.default)(PickupLocatorLauncher, _pickupLocatorLauncherStyles2.default, { allowMultiple: true });
exports.default = (0, _fluxWrapper2.default)(UnconnectedLauncher);


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Launcher/index.js
// module id = 2494
// module chunks = 0